import { map } from "nanostores"

export interface CartStoreProps {
  recipe_count: number
}

export const $cart = map<CartStoreProps>({
  recipe_count: typeof window === "undefined" ? 0 : window.happycart_initial_recipe_count,
})

export const open = () => {
  window.happycart?.openCart()
}

export const addRecipe = (id: number, portion_count: number) => {
  window.happycart?.addRecipeToCart(id.toString(), portion_count)
}

export const init = () => {
  const listener = (e: HappyCartRecipeUpdateEvent) => {
    $cart.setKey("recipe_count", e.detail.recipeCount)
  }

  window.addEventListener("HC_RECIPES_UPDATED", listener)
}
